module.exports = __webpack_public_path__ + "img/logo.6ab77c80.svg";